import React from 'react';
import { CTAButton } from './CTAButton';
const bonuses = [{
  id: 1,
  title: 'El Ojo del Asador',
  image: 'https://cdn.magicpatterns.com/uploads/rRZ1QxAkvZaf3gbDo8bR8C/mock_up_bono_1-removebg-preview.png',
  description: 'Para saber el punto de cualquier corte en 3 segundos sin termómetro.',
  bullets: ['4 láminas imprimibles con colores, texturas y señales visuales de punto por corte', 'Para tener pegadas al lado de la parrilla o guardadas en el celu para el momento exacto que las necesitás'],
  value: '$9.990'
}, {
  id: 2,
  title: 'La Libreta del Parrillero',
  image: 'https://cdn.magicpatterns.com/uploads/ve2grUHSqniyAoH4GDNr7s/heylloyd-image-1774652180163-removebg-preview.png',
  description: 'Para que cada asado te haga mejor en el siguiente.',
  bullets: ['Plantillas de registro, mapa de calor de tu parrilla específica', 'Plan de 4 fines de semana para desarrollar consistencia de verdad'],
  value: '$7.990'
}, {
  id: 3,
  title: 'Lo que el Fuego te Dice (y Vos No Escuchás)',
  image: 'https://cdn.magicpatterns.com/uploads/6iJXVFJ592sv5rjT9zZ6zy/bono_3-removebg-preview.png',
  description: 'Para leer el fuego como un asador de estancia.',
  bullets: ['Lo que el humo, la brasa, el sonido y la grasa te dicen sobre el estado del asado', 'Las señales que los asadores de campo leían hace generaciones y que hoy casi nadie conoce'],
  value: '$9.990'
}, {
  id: 4,
  title: 'El Salvataje del Domingo',
  image: 'https://cdn.magicpatterns.com/uploads/u7hnovzzPr3Cs7oRfmRH8e/BONO_4-removebg-preview.png',
  description: 'Para cuando algo sale mal y necesitás quedar bien igual.',
  bullets: ['12 cards de rescate express: abrís la card, seguís el protocolo, nadie nota que hubo un problema', 'Con el guion exacto de qué decir en cada situación para que parezca una decisión, no un error'],
  value: '$7.990'
}];
export function BonusSection() {
  return <section className="py-20 bg-zinc-900 border-y border-zinc-800" data-id="element-23">
      <div className="container mx-auto px-4" data-id="element-24">
        <div className="max-w-5xl mx-auto" data-id="element-25">
          <div className="text-center mb-16" data-id="element-26">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-27">
              🎁 Y ENCIMA TE LLEVÁS ESTOS 4 BONOS
            </h2>
          </div>

          <div className="space-y-12 mb-16" data-id="element-28">
            {bonuses.map(bonus => <div key={bonus.id} className="bg-zinc-950 border border-zinc-800 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-8 items-center" data-id="element-29">
                <div className="w-full md:w-1/3 flex justify-center" data-id="element-30">
                  <a href="#compra" className="block group cursor-pointer" data-id="element-31">
                    <img src={bonus.image} alt={bonus.title} className="w-48 md:w-56 h-auto object-contain transform transition-all duration-300 group-hover:-translate-y-2 group-hover:drop-shadow-[0_10px_20px_rgba(245,158,11,0.3)]" data-id="element-32" />
                  </a>
                </div>
                <div className="w-full md:w-2/3" data-id="element-33">
                  <div className="flex items-center gap-3 mb-2" data-id="element-34">
                    <span className="text-amber-500 font-bold" data-id="element-35">
                      🎁 BONO #{bonus.id}
                    </span>
                    <span className="bg-green-900/30 text-green-400 text-xs px-2 py-1 rounded border border-green-900/50" data-id="element-36">
                      GRATIS HOY
                    </span>
                  </div>
                  <h3 className="text-2xl font-serif font-bold text-white mb-2" data-id="element-37">
                    {bonus.title}
                  </h3>
                  <p className="text-zinc-300 italic mb-6" data-id="element-38">
                    {bonus.description}
                  </p>
                  <ul className="space-y-2 mb-6" data-id="element-39">
                    {bonus.bullets.map((bullet, i) => <li key={i} className="flex items-start text-zinc-400 text-sm" data-id="element-40">
                        <span className="text-amber-500 mr-2 mt-0.5" data-id="element-41">✓</span>
                        <span data-id="element-42">{bullet}</span>
                      </li>)}
                  </ul>
                  <div className="bg-zinc-900 inline-block px-4 py-2 rounded-lg border border-zinc-800" data-id="element-43">
                    <span className="text-zinc-500 line-through mr-2" data-id="element-44">
                      Valor {bonus.value}
                    </span>
                    <span className="text-amber-400 font-bold" data-id="element-45">
                      — Incluido sin costo extra hoy
                    </span>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="text-center" data-id="element-46">
            <CTAButton data-id="element-47" />
          </div>
        </div>
      </div>
    </section>;
}